var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from "react";
import "@gouvfr/dsfr/dist/component/form/form.css";
import "./TuileInterrupteur.css";
import classNames from "classnames";
import { SelectMj, ToggleMj } from "../../interface/Form";
import DisplayComment from "./DisplayComment";
import generateID from "../../../utils/string-utils";
var TuileInterrupteur = function (props) {
    var id = props.id, _a = props.icon, icon = _a === void 0 ? "" : _a, _b = props.label, label = _b === void 0 ? "" : _b, _c = props.name, name = _c === void 0 ? "" : _c, _d = props.value, value = _d === void 0 ? "" : _d, _e = props.withCommentText, withCommentText = _e === void 0 ? false : _e, _f = props.withCommentAccordion, withCommentAccordion = _f === void 0 ? false : _f, _g = props.accordionWithTextArea, accordionWithTextArea = _g === void 0 ? false : _g, _h = props.withDropDown, withDropDown = _h === void 0 ? "" : _h, remainingProps = __rest(props, ["id", "icon", "label", "name", "value", "withCommentText", "withCommentAccordion", "accordionWithTextArea", "withDropDown"]);
    var _id = useRef(id || generateID());
    useEffect(function () {
        _id.current = id || generateID();
    }, [id]);
    var _j = useState(), isChecked = _j[0], setIsChecked = _j[1];
    var handleSwitchChange = function (event) {
        setIsChecked(event.target.checked);
    };
    var dropDown = [];
    var displayDropdown = function () {
        for (var key in withDropDown) {
            if (withDropDown.hasOwnProperty(key)) {
                var values = withDropDown[key];
            }
            dropDown.push(React.createElement(SelectMj, { id: "tuile-select-" + _id.current, label: key, options: values }));
        }
        return dropDown;
    };
    var _ClassName = classNames(["tile-icon", "".concat(icon)]);
    var idName = name;
    return (React.createElement("div", { className: isChecked
            ? "tuile-interrupteur-on tuile dsmj-specifique-tuile-interrupteur"
            : "tuile-interrupteur-off tuile dsmj-specifique-tuile-interrupteur" },
        React.createElement("div", { className: "interrupteur check" },
            React.createElement(ToggleMj, __assign({}, remainingProps, { onClick: function (event) { return handleSwitchChange(event); }, id: "tuile-toggle-" + _id.current })),
            React.createElement("label", { className: "interrupteur-label", htmlFor: idName },
                React.createElement("span", { className: _ClassName }))),
        React.createElement("div", { className: "label-avec-commentaire" }, label),
        React.createElement("div", { className: isChecked ? "commentaire" : "commentaire disableContent" }, withCommentText ? (React.createElement(DisplayComment, { textLabel: "Commentaire", name: "testComment" })) : withDropDown ? (displayDropdown()) : withCommentAccordion ? (React.createElement(DisplayComment, { textLabel: "Commentaire", name: "testCommentDisplay", display: true })) : null)));
};
export default TuileInterrupteur;
